import { render, staticRenderFns } from "./discoverOne.vue?vue&type=template&id=8b1cf108&"
import script from "./discoverOne.vue?vue&type=script&lang=js&"
export * from "./discoverOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports